import React, { useEffect, useState } from 'react'
import {
  Breadcrumb,
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Modal,
  Row,
  Table
} from 'react-bootstrap'
import './style.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch'
import { Formik } from 'formik';
import Write from 'asset/SvgComponent/Write'
import Delete from 'asset/SvgComponent/Delete'
import EditIcon from 'asset/SvgComponent/EditIcon'
import Pagination from 'components/Pagination'
import Loader from 'components/Loader'
import Alert from 'components/Alert'
import Dialog from 'components/Dialog'
import axios from 'api/index'
import { IAPI_Response } from 'api/types'
import { 
  API_ENDPOINT,
  SUCCESS_MESSAGE,
  ERROR_MESSAGE,
  TEXT
} from 'utils/globalConstant'
import { validationSchema } from './validationSchema'
import { IHolidayType, IList, IItem } from './types'

export default function Index() {
  const [currentPage, setCurrentPage] = React.useState(0)
  const [lastPage, setLastPage] = React.useState(0)
  const [itemsPerPage, setPerPage] = React.useState(10)
  const [itemsCount, setItemCount] = React.useState(0)
  const [from, setFrom] = React.useState(0)

  const [validation, setValidation] = React.useState('')
  const [error, setError] = React.useState('')
  const [success, setSuccess] = React.useState('')
  const [showError, setShowError] = React.useState(false)
  const [showSuccess, setShowSuccess] = React.useState(false)
  const [showLoading, setShowLoading] = React.useState(false)

  const [showCreate, setShowCreate] = React.useState(false)
  const handleCloseCreate = () => setShowCreate(false)
  const handleShowCreate = () => setShowCreate(true)

  const [showEdit, setShowEdit] = React.useState(false)
  const handleCloseEdit = () => setShowEdit(false)
  const handleShowEdit = () => setShowEdit(true)

  const [showConfirm, setShowConfirm] = React.useState(false)
  const handleCloseConfirm = () => setShowConfirm(false)
  const handleShowConfirm = (id: any) => {
    setShowConfirm(true)
    setItem({
      id: id,
      holiday_type_name: '',
      rate_of_basic: ''
    })
  }

  const [lists, setData] = useState<IList[]>([])
  const [item, setItem] = useState<IItem>({
    id: 0,
    holiday_type_name: '',
    rate_of_basic: ''
  })

  const getHolidayType = async (page_number: null | number) => {
    setShowLoading(true)
    try {
      const res = await axios.get<IAPI_Response<IHolidayType>>(API_ENDPOINT.GET_HOLIDAY_TYPE, {
        params: {
          page: page_number,
        },
      })
      const result = await res
      if (result?.data?.results?.data?.length) {
        setData(result?.data?.results?.data)
        setCurrentPage(result?.data?.results?.current_page)
        setLastPage(result?.data?.results?.last_page)
        setPerPage(result?.data?.results?.per_page)
        setItemCount(result?.data?.results?.total)
        setFrom(result?.data?.results?.from)
      }
      setShowLoading(false)
    } catch {
      setShowError(true)
      setError(ERROR_MESSAGE.SYSTEM_ERROR)
    }

    setTimeout(() => {
      setShowError(false)
    }, 3000);
  }

  const showHolidayType = async (id: null | number) => {
    try {
      const response = await axios.get<IAPI_Response<IItem>>(API_ENDPOINT.SHOW_HOLIDAY_TYPE +'/'+ id)
      const result = await response
      if (result?.data?.results) {
        setItem(result?.data?.results)
      }
      handleShowEdit()
    } catch {
      setShowError(true)
      setError(ERROR_MESSAGE.SYSTEM_ERROR)
    }

    setTimeout(() => {
      setShowError(false)
    }, 3000);
  }

  const postHolidayType = async (value: any, {resetForm} : any) => {
    await axios.post(API_ENDPOINT.POST_HOLIDAY_TYPE, {
      holiday_type_name: value.holiday_type_name,
      rate_of_basic: value.rate_of_basic,
    }).then(response => {
       if (response?.data?.status * 1 === 1) {
          setShowSuccess(true)
          setSuccess(SUCCESS_MESSAGE.HOLIDAY_TYPE.CREATED)
          getHolidayType(null);
       }
       resetForm({})
       handleCloseCreate();
    }).catch(error => {
       setValidation(error.response.data.message)
    })

    setTimeout(() => {
      setShowSuccess(false)
      setShowError(false)
      setValidation('')
    }, 3000);
  }

  const updateHolidayType = async (value: any, {resetForm} : any) => {
    await axios.put(API_ENDPOINT.PUT_HOLIDAY_TYPE +'/'+ value.id, {
      holiday_type_name: value.holiday_type_name,
      rate_of_basic: value.rate_of_basic
    }).then(response => {
       if (response?.data?.status * 1 === 1) {
          setShowSuccess(true)
          setSuccess(SUCCESS_MESSAGE.HOLIDAY_TYPE.UPDATED)
          getHolidayType(null);
       }
       resetForm({})
       handleCloseEdit();
    }).catch(error => {
      setValidation(error.response.data.message)
    })
    
    setTimeout(() => {
      setShowSuccess(false)
      setShowError(false)
      setValidation('')
    }, 3000);
  }

  const deleteHolidayType = async (id: null | number) => {
    try {
      const response = await axios.delete(API_ENDPOINT.DELETE_HOLIDAY_TYPE +'/'+ id)
      const result = await response
      if (result?.data?.status * 1 === 1) {
        setShowSuccess(true)
        setSuccess(SUCCESS_MESSAGE.HOLIDAY_TYPE.DELETED)
        getHolidayType(null);
     }
    } catch {
      setShowError(true)
      setError(ERROR_MESSAGE.SYSTEM_ERROR)
    }
    handleCloseConfirm()
    setTimeout(() => {
      setShowSuccess(false)
      setShowError(false)
    }, 3000);
  }

  useEffect(() => {
    ;(async () => {
      getHolidayType(null)
    })()
  }, [])

  return (
    <>
      <Container fluid>
        <h5 className='fw-bold'>Holiday Type</h5>
        <Breadcrumb className='breadcrumbs'>
          <Breadcrumb.Item className=' text-decoration-none' href='/home'>
            Home
          </Breadcrumb.Item>
          <Breadcrumb.Item className=' text-decoration-none' href='#'>
            Setup
          </Breadcrumb.Item>
          <Breadcrumb.Item className=' text-decoration-none' href='/leaves/holiday-type'>
            Leaves
          </Breadcrumb.Item>
          <Breadcrumb.Item active>Holiday Type</Breadcrumb.Item>
        </Breadcrumb>

        <Alert 
          type="success" 
          show={showSuccess} 
          message={success} 
          setShow={() => { 
              setShowSuccess(false);
            }
          }
        />

        <Alert 
          type="error" 
          show={showError} 
          message={error} 
          setShow={() => { 
            setShowError(false);
            }
          }
        />
        
        <Card className='border-0  p-0 bordered-card'>
          <Card.Body>
            <Row>
              <Col sm={6}>
                <span className='fw-bold'>Holiday Types</span>
              </Col>
              <Col sm={6} className='d-flex justify-content-end hidden'>
                <InputGroup size='sm' className={'w-25'}>
                  <Form.Control
                    aria-label='search'
                    aria-describedby='inputGroup-sizing-sm'
                    placeholder='Search...'
                  />
                  <InputGroup.Text className='bg-transparent search-input '>
                    <FontAwesomeIcon icon={faSearch} />
                  </InputGroup.Text>
                </InputGroup>
                <Button
                  onClick={handleShowCreate}
                  className=' add-new-btn rounded mx-2 text-white'
                  variant='warning'
                  >
                  <EditIcon/>
                  &nbsp;Add Holiday Type
                </Button>
              </Col>
            </Row>
            {/* <hr/>*/}
            <Table responsive className='bordered-tabs-top mt-3'>
              <thead>
                <tr>
                  <th style={{ width: '5%' }}>No.</th>
                  <th style={{ width: '15%' }}>Holiday Type</th>
                  <th style={{ width: '15%' }}>Rate of Basic</th>
                  <th className='text-center'>Actions</th>
                </tr>
              </thead>
              <tbody>
              <>
                {lists.length > 0 ? (
                  lists.map((item, index) => 
                    <tr className='mb-2' key={index}>
                      <td>{from + index}</td>
                      <td>{item.holiday_type_name}</td>
                      <td>{item.rate_of_basic}</td>
                      <td className='text-center'>
                        <Button
                          onClick={() => showHolidayType(item.id)}
                          className=' p-1 pt-0 pb-0'
                          style={{ fontSize: '12px', color: 'white' }}
                          variant=' btn-transparent'
                          size='sm'
                          >
                          <Write/>
                        </Button>
                        <Button
                          onClick={() => handleShowConfirm(item.id)}
                          className=' p-1 pt-0 pb-0'
                          style={{ fontSize: '12px', color: 'white' }}
                          variant=' btn-transparent'
                          size='sm'
                            >
                          <Delete/>
                        </Button>
                      </td>
                      <br />
                    </tr>
                  )
                  ) : (
                  <tr className='no-item'>
                    <td colSpan={4}>{TEXT.NOT_FOUND}</td>
                  </tr>
                )}
              </>
              </tbody>
            </Table>
            <Pagination
              itemsCount={itemsCount}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              lastPage={lastPage}
              setCurrentPage={setCurrentPage}
              alwaysShown={false}
              pageClicked={(page: number) => { 
                  getHolidayType(page);
                }
              }
              />

            <Dialog 
              show={showConfirm} 
              setShow={handleCloseConfirm}
              setEvent={() => { 
                  deleteHolidayType(item.id)
                }
              }
            />

            <Loader show={showLoading}/>
          </Card.Body>
        </Card>
        
        {/* ADD MODAL*/}
        <Formik
            initialValues={
              { 
                holiday_type_name: '',
                rate_of_basic: ''
              }
            }
            validationSchema={validationSchema}
            onSubmit={postHolidayType}
            >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting
            }) => (
            <Form id="holidayTypeCreate" noValidate onSubmit={handleSubmit}>
              <Modal className='modal border-0' centered show={showCreate} onHide={handleCloseCreate}>
                <Modal.Header closeButton>
                  <Modal.Title className='fw-bold'>Add New Holiday Type</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col sm={9}>
                      <Form.Group className='mb-3' controlId='exampleForm.ControlInput1'>
                        <Form.Label className='text-muted fw-bold required'>Holiday Type</Form.Label>
                        <Form.Control 
                          size={'sm'} 
                          type='text' 
                          placeholder='Type of Holidays'
                          name="holiday_type_name"
                          value={values.holiday_type_name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.holiday_type_name && !!errors.holiday_type_name || !!validation}
                          />
                        {
                        validation != '' ?
                          (Object.keys(validation).map((message : any, index) => (
                            <Form.Control.Feedback type="invalid" key={index}>
                              {validation[message][index]}
                            </Form.Control.Feedback>
                          ))
                          ) : (
                          <Form.Control.Feedback type="invalid">
                            {errors.holiday_type_name}
                          </Form.Control.Feedback>
                          )
                        }
                      </Form.Group>
                    </Col>
                    <Col sm={3}>
                      <Form.Group className='mb-3' controlId='exampleForm.ControlInput1'>
                        <Form.Label className='text-muted fw-bold required'>Rate of Basic</Form.Label>
                        <Form.Control 
                          size={'sm'} 
                          type='number' 
                          step='.5' 
                          placeholder='0'
                          name="rate_of_basic"
                          value={values.rate_of_basic}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.rate_of_basic && !!errors.rate_of_basic}
                          />
                        <Form.Control.Feedback className="left" type="invalid">
                          {errors.rate_of_basic}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant='outline-primary' size={'sm'} onClick={handleCloseCreate}>
                    Cancel
                  </Button>
                  <Button type="submit" disabled={isSubmitting} form="holidayTypeCreate" variant='primary text-white' className='mx-2' size={'sm'}>
                    Save
                  </Button>
                </Modal.Footer>
              </Modal>
            </Form>
            )}
        </Formik>

        {/* EDIT MODAL*/}
        <Formik
            initialValues={item}
            validationSchema={validationSchema}
            onSubmit={updateHolidayType}
            enableReinitialize
            >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting
            }) => (
            <Form id="holidayTypeUpdated" noValidate onSubmit={handleSubmit}>
              <Modal className='modal border-0' centered show={showEdit} onHide={handleCloseEdit}>
                <Modal.Header closeButton>
                  <Modal.Title className='fw-bold'>Edit Holiday Type</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col sm={9}>
                      <Form.Group className='mb-3' controlId='exampleForm.ControlInput1'>
                        <Form.Label className='text-muted fw-bold required'>Holiday Type</Form.Label>
                        <Form.Control 
                          size={'sm'} 
                          type='text' 
                          placeholder='Type of Holidays'
                          name="holiday_type_name"
                          value={values.holiday_type_name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.holiday_type_name && !!errors.holiday_type_name || !!validation}
                          />
                        {
                        validation != '' ?
                          (Object.keys(validation).map((message : any, index) => (
                            <Form.Control.Feedback type="invalid" key={index}>
                              {validation[message][index]}
                            </Form.Control.Feedback>
                          ))
                          ) : (
                          <Form.Control.Feedback type="invalid">
                            {errors.holiday_type_name}
                          </Form.Control.Feedback>
                          )
                        }
                      </Form.Group>
                    </Col>
                    <Col sm={3}>
                      <Form.Group className='mb-3' controlId='exampleForm.ControlInput1'>
                        <Form.Label className='text-muted fw-bold required'>Rate of Basic</Form.Label>
                        <Form.Control 
                          size={'sm'} 
                          type='number' 
                          step='.5' 
                          placeholder='0'
                          name="rate_of_basic"
                          value={values.rate_of_basic}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.rate_of_basic && !!errors.rate_of_basic}
                          />
                        <Form.Control.Feedback className="left" type="invalid">
                          {errors.rate_of_basic}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant='outline-primary' size={'sm'} onClick={handleCloseCreate}>
                    Cancel
                  </Button>
                  <Button type="submit" disabled={isSubmitting} form="holidayTypeUpdated" variant='primary text-white' className='mx-2' size={'sm'}>
                    Update
                  </Button>
                </Modal.Footer>
              </Modal>
            </Form>
            )}
        </Formik>
      </Container>
    </>
  )
}
